import { useState } from "react";
import logo from "../assets/logo.png";
import headerBg from "../assets/cover.jpg";
import AdminOverview from "./poweradmin/PowerOverview";
import AdminLogs from "./poweradmin/PowerLogs";
import AdminUsers from "./poweradmin/PowerUsers";
import AdminDevices from "./poweradmin/PowerDevices";
import { useNavigate, useLocation } from "react-router-dom";

export default function PowerAdmin() {
  const [page, setPage] = useState("overview");
  const navigate = useNavigate();

  const location = useLocation();
  const tabs = [
    { key: "overview", label: "Overview" },
    { key: "logs", label: "Access Logs" },
    { key: "users", label: "Manage Users" },
    { key: "devices", label: "Manage Devices" },
  ];

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <div
        className="relative w-full h-20 flex items-center justify-between px-6 shadow-md"
        style={{
          backgroundImage: `url(${headerBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black opacity-30"></div>
        <div className="relative z-10 flex items-center">
          <img src={logo} alt="SSD Logo" 
        onClick={() => navigate("/")}
          className="h-12 mr-3" />
        </div>
        <h1 className="absolute left-1/2 transform -translate-x-1/2 z-10 text-white font-bold text-3xl tracking-wide">
          Safe Power Admin
        </h1>
      </div>

      {/* Tabs */}
      <div className="flex justify-between items-center mb-6 border-b px-6 pt-4">
        {/* Left Tabs */}
        <div className="flex space-x-6">
        {tabs.map((item) => (
          <button
            key={item.key}
            onClick={() => setPage(item.key)}
            className={`relative pb-2 text-sm font-medium transition-colors duration-200
              ${
                page === item.key
                  ? "text-blue-600 after:content-[''] after:absolute after:left-0 after:bottom-0 after:h-0.5 after:w-full after:bg-blue-600"
                  : "text-gray-600 hover:text-blue-500"
              }`}
          >
            {item.label}
          </button>
          ))}
        </div>

        <div className="flex space-x-6">
          <button
            onClick={() => navigate("/admin")}
            className={`pb-2 text-sm font-medium transition-colors duration-200
              ${location.pathname === "/admin"
                ? "text-black font-semibold border-b-2 border-black cursor-default"
                : "text-blue-600 hover:text-blue-500"}`}
            disabled={location.pathname === "/admin"}
          >
            Absen
          </button>
          <button
            onClick={() => navigate("/poweradmin")}
            className={`pb-2 text-sm font-medium transition-colors duration-200
              ${location.pathname === "/poweradmin"
                ? "text-black font-semibold border-b-2 border-black cursor-default"
                : "text-blue-600 hover:text-blue-500"}`}
            disabled={location.pathname === "/poweradmin"}
          >
            Power
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="px-6 pb-6">
        {page === "overview" && <AdminOverview />}
        {page === "logs" && <AdminLogs />}
        {page === "users" && <AdminUsers />}
        {page === "devices" && <AdminDevices />}
      </div>
    </div>
  );
}
